var React = require('react');

function LeftArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"r":"27","transform":"matrix(-1 0 0 1 28 28)","stroke":"white","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M39 28H18","stroke":"white","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M26 20L17.5 28L26 36","stroke":"white","strokeWidth":"2","key":2})]);
}

LeftArrowInline.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = LeftArrowInline;

LeftArrowInline.default = LeftArrowInline;
